import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { DocumentService } from 'src/app/core/services/document.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { isBuffer } from 'util';
import { Common } from 'src/app/core/constants/common';

export interface Signer {
  id: string;
  fullName: string;
  userName: string;
  enterprise: string;
}
@Component({
  selector: 'app-submission',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.css']
})
export class SubmissionComponent implements OnInit, OnDestroy {

  submission = {
    idContract: '',
    idSigner: ''
  };

  /**
   * Document name
   */
  documentName: '';

  /**
   * name of signer
   */
  name: '';

  /**
   * Check success
   */
  success = false;

  isAutoSign: boolean = false;

  // Columns of table
  displayedColumns: string[] = ['fullName', 'userName', 'enterprise'];
  // Data for table
  signers: Signer[];

  hasDigitalCertificateServer = false;

  //current status when signed
  isCurrentStatus: number = 1;
  page: number;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  customerName: '';
  status: '';
  serviceType: '';
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<SubmissionComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private commonService: CommonService,
    private digitalCertificateService: DigitalCertificateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    // Get data from ViewDocumentComponent
    this.submission.idContract = data.id;
    this.documentName = data.name;
    this.isAutoSign = data.isAutoSign;
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    this.getSigners(this.data.id);
    this.notificationService.subscribeErrorService();

    this.activatedRoute
    .queryParams
    .subscribe(params => {
      this.page = params.page || 0;
      this.pageSize = params.pageSize || 0;
      this.routeLink = params.routeLink || null;
      this.enterprise = params.enterprise || null;
      this.documentTypeSearch = params.documentType || null;
      this.nameOrCode = params.nameOrCode || null;
      this.customerName = params.customerName || null;
      this.status = Common.DOCUMENT_STATUS.indexOf(params.status) == -1 ? null : params.status;
      this.serviceType = params.serviceType || null;
      this.taxCode = params.taxCode || null;
      this.createdUser = params.createdUser || null;
      this.createdTimeFrom = params.createdTimeFrom || null;
      this.createdTimeTo = params.createdTimeTo || null;
      this.finishDateFrom = params.finishDateFrom || null;
      this.finishDateTo = params.finishDateTo || null;
      this.sortColumn = params.sortColumn || null;
      this.sortDirection = params.sortDirection || null;
      this.goFrom = params.goFrom || null;
    });
  }

  getDigitalCertificateServer() {
    this.digitalCertificateService.getCertificatesWithType(0).subscribe(rs => {
      const data = rs && rs.data;
      this.hasDigitalCertificateServer = data && data.length;
    });
  }

  highlight(row) {
    this.submission.idSigner = row.id;
    this.name = row.name;
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get ServiceType list to show for combobox
   */
  getSigners(documentId) {
    this.documentService.getSigners(documentId).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.signers = rs.data;
      // Set highlight for first row when init
      this.submission.idSigner = rs.data[0].id;
      this.name = rs.data[0].name;
    });
  }

  /**
   * Save Submission
   */
  saveSubmission() {
    if (this.isAutoSign) {
      // this.digitalCertificateService.getServerCertificatesWithSigner(this.submission.idSigner).subscribe(rs => {
      //   this.hasDigitalCertificateServer = rs && rs.data && rs.data.length > 0;
      //   const messageKey = this.hasDigitalCertificateServer ? 'messages.confirm_submission_has_cts' : 'messages.confirm_submission_no_cts';
      //   let warning = { width: '30%', data: this.message.getMessage(messageKey) };
      //   this.dialog.open(WarningComponent, warning).afterClosed().subscribe(confirmResult => {
      //     if (confirmResult) {
      //       this.docSaveSubmission(this.hasDigitalCertificateServer);
      //     }
      //   });
      // });
    } else {
      this.confirmSubmit();
    }
  }

  confirmSubmit() {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_change_submission'),
        '<strong>' + this.documentName + '</strong>', '<strong>' + this.name + '</strong>')
    });

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.docSaveSubmission();

        this.router.navigate([this.routeLink], {
          queryParams: {
            page: this.page,
            pageSize: this.pageSize,
            enterprise: this.enterprise,
            documentType: this.documentTypeSearch,
            nameOrCode: this.nameOrCode,
            customerName: this.customerName,
            status: this.isCurrentStatus,
            serviceType: this.serviceType,
            taxCode: this.taxCode,
            createdUser: this.createdUser,
            createdTimeFrom: this.createdTimeFrom,
            createdTimeTo: this.createdTimeTo,
            finishDateFrom: this.finishDateFrom,
            finishDateTo: this.finishDateTo,
            sortColumn: this.sortColumn,
            sortDirection: this.sortDirection
          }
        });
      }
    });
  }

  docSaveSubmission(autoSign: boolean = false) {
    this.documentService.saveSubmission(this.submission)
      .subscribe(res => {
        this.success = true;
        if(autoSign){
          this.toastr.success(this.message.getMessage('messages.submission_auto_sign'));
        } else {
          this.toastr.success(this.message.getMessage('messages.submission'));
        }
        this.dialogRef.close();
      });
  }

  /**
   * Close pop-up
   */
  cancel() {
    this.dialogRef.close();
  }
}
